var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReseller3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 55 55",
    width: 55,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.06 24C36.07 23.67 36.07 23.33 36.07 23C35.6 23 33.24 23 29 23C29 34.34 29 40.64 29 41.9C29.35 41.59 29.68 41.27 30 40.96C30 39.83 30 34.17 30 24C33.64 24 35.66 24 36.06 24Z",
    id: "cJEmwD8pD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 1L43 1L43 5.63L42 4L34 17C35.8 17 36.8 17 37 17C37 31.87 40.31 46.74 2 53.82C2 53.81 2 53.78 2 53.78C1.66 53.84 1.33 53.89 1 53.94C1 53.94 1 53.96 1 54L1 55L11 55L15 55L25 55L29 55L39 55L43 55L53 55L55 55L55 54L53 54L53 1ZM38 17C38 16.93 38 16.6 38 16L37 16L35.79 16L42 5.91L48.21 16L47 16L46 16C46 16.6 46 16.93 46 17C46 29.56 44.86 37.97 39.04 43.79C33.9 48.93 25.27 51.78 11.63 52.68C38.45 45.39 38.24 32.65 38.04 20.28C38.02 19.19 38 18.1 38 17ZM2 53.99C4.84 53.98 7.5 53.9 10 53.76C10 53.78 10 53.86 10 54L2 54C2 53.99 2 53.99 2 53.99ZM11 53.71C12.38 53.62 13.72 53.52 15 53.4C15 53.44 15 53.64 15 54L11 54C11 53.82 11 53.73 11 53.71ZM16 53.29C18.93 52.97 21.59 52.55 24 52.03C24 52.16 24 52.82 24 54L16 54C16 53.57 16 53.33 16 53.29ZM25 51.8C26.42 51.47 27.75 51.09 29 50.68C29 50.9 29 52.01 29 54L25 54C25 52.68 25 51.95 25 51.8ZM30 50.35C33.24 49.18 35.86 47.74 38 46.04C38 46.57 38 49.22 38 54L30 54C30 51.81 30 50.59 30 50.35ZM39 45.19C40.64 43.71 41.95 42.04 43 40.2C43 41.12 43 45.72 43 54L39 54C39 48.71 39 45.78 39 45.19ZM44 54C44 44.52 44 39.26 44 38.21C46.49 32.57 47 25.47 47 17C47.2 17 48.2 17 50 17L44 7.25L44 2L52 2L52 54L44 54Z",
    id: "a6vgbpqaTY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 40C10 46.49 10 50.1 10 50.82C10.34 50.73 10.67 50.64 11 50.55C11 49.78 11 45.93 11 39L1 39C1 47.29 1 51.89 1 52.82C1.34 52.75 1.67 52.69 2 52.63C2 51.79 2 47.58 2 40L10 40Z",
    id: "j3CDSDzUc9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 32C24 40.06 24 44.54 24 45.43C24.34 45.24 24.68 45.04 25 44.84C25 43.92 25 39.31 25 31L15 31C15 42 15 48.11 15 49.33C15.34 49.22 15.67 49.1 16 48.99C16 47.85 16 42.19 16 32L24 32Z",
    id: "a2ktIDswrP"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cJEmwD8pD",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cJEmwD8pD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6vgbpqaTY",
    opacity: 1,
    fill: "#37474f",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6vgbpqaTY",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j3CDSDzUc9",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j3CDSDzUc9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2ktIDswrP",
    opacity: 1,
    fill: "#37474f",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2ktIDswrP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReseller3);
export default __webpack_public_path__ + "static/media/reseller-3.e4017aa5a2ebbeb12801e60188b2df9e.svg";
export { ForwardRef as ReactComponent };